import { TransactionAdjustmentType } from "../enums/adjustment-type.enum";

export class CreateTransactionAdjustmentRequest {
  transaction_id: string;
  card_id: string;
  cardholder_id: string;
  transaction_date: string;
  amount?: number;
  reason?: string;
  type?: TransactionAdjustmentType;
  brand_claim_id?: string;
  dispute_id?: string;
  chargeback_id?: string;

  constructor(
    transaction_id: string,
    card_id: string,
    cardholder_id: string,
    transaction_date: string,
    amount?: number,
    reason?: string,
    type?: TransactionAdjustmentType,
    brand_claim_id?: string,
    dispute_id?: string,
    chargeback_id?: string
  ) {
      this.transaction_id = transaction_id;
      this.reason = reason;
      this.type = type;
      this.amount = amount;
      this.cardholder_id = cardholder_id;
      this.card_id = card_id;
      this.transaction_date = transaction_date;
      this.brand_claim_id = brand_claim_id;
      this.dispute_id = dispute_id;
      this.chargeback_id = chargeback_id;
    }
}